import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import Toggle from './../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { aftcabinImageOptions } from './views/aftcabin'

class X46AftCabin extends Component {
    constructor(props) {
        super(props);
        this.handleCabinChange = this.handleCabinChange.bind(this);
        this.handleShelvingChange = this.handleShelvingChange.bind(this);
    }
    
    handleCabinChange(newValue) {
        let configuration = this.props.configuration;
        configuration.SplitBerth = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }
    
   

    handleShelvingChange(event) {
        let configuration = this.props.configuration;
        configuration.AftCabinShelving = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = aftcabinImageOptions;

        let image = <ConfiguratorImage boat="X4_6" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Aft Cabins' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='Standard of the X4<sup>6</sup> is double berth in both aft cabins.' /></p>
                    <p><Trans defaults='Optional is a split berth in port side aft cabin and freeboard hung sea berths in both cabins (sea berths are not shown on this rendering. Furthermore, please note that sea berths are not an option if upper shelves are selected).' /></p>
                    <p><Trans defaults='For extra storage, upper shelves in both aft cabins is an option.' /></p>
                    <p><Trans defaults='On this image, the cabin is shown with ambient lighting fitted in hull deck joint.' /></p>
                    <RadioGroup options={this.props.aftCabinOptions} value={this.props.configuration.SplitBerth} onChange={this.handleCabinChange} />

                    <Toggle checked={this.props.configuration.AftCabinShelving.value === 2} onChange={this.handleShelvingChange}>
                        <Trans defaults='Upper shelves' />
                    </Toggle>

                    
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X46AftCabin);


// WEBPACK FOOTER //
// ./src/X46/X46AftCabin.js